export const TICKER = "$FLART";
export const CA = "9x4nhMHb46DcCzYkUJ6VaK29YnbCU4wA3VDmJWyCpump";
export const DISCORD = "https://discord.gg/6kHzCVXubD";
export const TIKTOK = "https://www.tiktok.com/@aifartlab";
export const TWITTER = "https://x.com/AIFartLab";
export const TWITTER_FOLLOW = "https://x.com/intent/follow?screen_name=AIFartLab";
export const GITHUB = "https://github.com/FartLab/fartlab-solana-program";
export const WEB_APP_LINK = "https://xyz.fartlab.app/";
export const TELEGRAM = "https://t.me/aifartlab";
export const CONTACT_EMAIL = "hi.fartlab@gmail.com";

export const PROGRAM_ID = "5pQhCajjGt2gMYi1m9irZw47KaEHL3V8a3KoSTLMAkqR";

